import { Alert, Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    title: string,
    onDiscard: () => void,
    onCancel: () => void
}

const DataChangedWarning = (props: IProps) => {
    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Data Change Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='warning' style={{ textAlign: 'center', marginBottom: 0 }}>
                    <div style={{ marginBottom: 10 }}>WARNING! You have pending changes in this tab.</div>
                    <div>Are you sure you want to discard these changes, before going to the {props.title} tab?</div>
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='warning' onClick={props.onDiscard}>Yes, Discard Changes</Button>
                <Button onClick={props.onCancel}>No, Return to Page</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DataChangedWarning;